import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router';

type SearchParamConfig = {
  prefix: 'frame' | 'task' | 'project' | 'user' | 'userGroup' | 'modeling';
  limit?: number;
  offset?: number;
};

type SearchParamsGuardProps = { configs: SearchParamConfig[] };

const SearchParamsGuard = ({ configs }: SearchParamsGuardProps) => {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const location = useLocation();

  configs.forEach(({ prefix, limit = 20, offset = 0 }) => {
    const configOffset = searchParams.get(`${prefix}Offset`);
    const configLimit = searchParams.get(`${prefix}Limit`);

    if (configLimit == null) params.set(`${prefix}Limit`, `${limit}`);
    if (configOffset == null) params.set(`${prefix}Offset`, `${offset}`);
  });

  if (searchParams.toString() !== params.toString()) {
    return <Navigate to={`${location.pathname}?${params}`} replace />;
  }

  return <Outlet />;
};

export default SearchParamsGuard;
